import styled from 'styled-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Card from 'components/Card/Card';

function LoginLayout({ children, history, verifyLogin = true }) {
  const authState = useSelector(state => state.authState);
  if (
    authState.authenticated &&
    authState.firestoreUser.completed &&
    verifyLogin
  ) {
    history.push('/');
  }

  return (
    <AuthPageContainer>
      <Card
        height="100vh"
        margin="0"
        row
        style={{ justifyContent: 'center', alignItems: 'center' }}
      >
        <FormSection>{children}</FormSection>
      </Card>
    </AuthPageContainer>
  );
}

export default withRouter(LoginLayout);

export const AuthPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(
    to bottom left,
    ${props => props.theme.palette.primary['500']},
    ${props => props.theme.palette.primary['700']}
  );
  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: url('https://images.pexels.com/photos/1932264/pexels-photo-1932264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260');
    opacity: 0.1;
    z-index: 1;
  }
`;

export const FormSection = styled.div`
  width: 400px;
  padding: 30px;
  @media (max-width: 500px) {
    padding: 1em;
  }
`;
